import React from "react";
import { statusText, statusTone } from "./model/shipmentStatus";
import type { TowerListedShipment } from "../../types/controlTower";
import { activateOnKey } from "./model/towerShared";

// Lista de envíos sueltos, no de choferes: lo que está en el depósito y las
// ubicaciones por revisar. El estado va al final, como "Seguimiento" en las zonas.
// Con onSelectDriver, la fila de un envío con chofer abre el detalle de ese chofer.
export default function TowerShipmentList({
  shipments,
  showZone,
  operationalDateLabel,
  emptyText,
  onSelectDriver,
}: {
  shipments: TowerListedShipment[];
  showZone: boolean;
  operationalDateLabel: string;
  emptyText: string;
  onSelectDriver?: (driverId: string) => void;
}) {
  const columns = showZone ? 6 : 5;
  return (
    <div className="tower-table-scroll">
      <table className="tower-table">
        <thead>
          <tr>
            <th>Cliente / tracking</th>
            <th>Destino</th>
            {showZone && <th>Zona</th>}
            <th>Asignado a</th>
            <th>{operationalDateLabel}</th>
            <th>Estado actual</th>
          </tr>
        </thead>
        <tbody>
          {shipments.map((s) => {
            const driverId = onSelectDriver && s.driverId;
            const open = driverId ? () => onSelectDriver(driverId) : undefined;
            return (
              <tr
                key={s.id}
                className={open ? "tower-driver-row" : undefined}
                tabIndex={open ? 0 : undefined}
                aria-label={open ? `Abrir envíos de ${s.assignedTo}` : undefined}
                onClick={open}
                onKeyDown={open && activateOnKey(open)}
              >
                <td>
                  <strong className="tower-client">{s.client}</strong>
                  <small>{s.tracking}</small>
                </td>
                <td>
                  {s.address || "Sin dirección"}
                  <small>
                    {s.locality || "Sin localidad"} · CP {s.postalCode || "sin informar"}
                  </small>
                </td>
                {showZone && <td>{s.zone === "Sin clasificar" ? "Por revisar" : s.zone}</td>}
                <td>{s.assignedTo}</td>
                <td>
                  {s.operationalDate || "Sin fecha"}
                  {s.fromPreviousDays && <small>De días anteriores</small>}
                </td>
                <td>
                  <span className={`tower-state ${statusTone(s)}`}>{statusText(s)}</span>
                  <small>{s.rawStatus}</small>
                  <small>{s.stateDate || "Sin fecha de estado"}</small>
                </td>
              </tr>
            );
          })}
          {shipments.length === 0 && (
            <tr>
              <td colSpan={columns} className="tower-empty">
                {emptyText}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
